import React from 'react';
import CountUp from 'react-countup';
import { Reveal } from '../SectionHeading';
import { STATS } from '../../data/siteData';

export const TrustCounters = () => (
  <section data-testid="trust-counters" className="bg-white border-b border-slate-200">
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-14 md:py-16">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 md:gap-6">
        {STATS.map((s, i) => (
          <Reveal key={s.label} delay={i * 0.08} className="text-center lg:text-left lg:border-l lg:border-slate-200 lg:pl-8 first:border-l-0 first:pl-0">
            <div className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#0A192F] font-heading tracking-tight">
              <CountUp end={s.value} duration={2.2} separator="," enableScrollSpy scrollSpyOnce />{s.suffix}
            </div>
            <div className="mt-2 text-sm font-medium text-slate-500 uppercase tracking-wider">{s.label}</div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
